import React from 'react';

import TextPane from 'pages/components/TextPane';

import { logPropTypes } from './utils';

const AuditTrailDetailsMessage = props => {
  const { log } = props;
  const { message } = log;

  return (
    <div className="cr-flex cr-flex-1 cr-ph-3 cr-pv-2">
      <TextPane
        className="cr-flex-1 cr-bg-snow cr-border-gray-100 cr-border-width-1 cr-border-style-solid cr-radius-1"
        style={{ height: '10rem' }}
        clipboard
      >
        {message}
      </TextPane>
    </div>
  );
};

AuditTrailDetailsMessage.propTypes = {
  log: logPropTypes,
};

export default AuditTrailDetailsMessage;
